import { HttpClient } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';

@Injectable()
export class RosterPreferenceApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getRosterPreferenceValidationForRequestItem(requestId: string) {
        return this.http.get(
            this.baseUri + 
            `/rosterPreference/rosterPreferenceValidation/requestItem/${requestId}`
        );
    }

    getRosterPreferenceValidationForUserRequest(userRequestId: string) {
        return this.http.get(
            this.baseUri + 
            `/rosterPreference/rosterPreferenceValidation/userRequest/${userRequestId}`
        );
    }
}